import React from 'react'
import PropTypes from 'prop-types'

import { Modal, Button, Alert } from 'shpmtcd'

class DeleteAddress extends React.Component {
  render() {
    const {
      showDeleteModal, onDelete, onCancel, showDeleteErrorMessage, errorMessage,
    } = this.props
    return (
      <Modal
        title='Delete this address?'
        width={300}
        wrapClassName='vertical-center-modal delete-address-modal'
        visible={showDeleteModal}
        onOk={onDelete}
        onCancel={onCancel}
        footer={[
          <Button key='cancel' type='Default' onClick={onCancel}>Cancel</Button>,
          <Button key='delete' type='Warning' onClick={onDelete}>Delete</Button>,
        ]}
      >
        <p>Are you sure you want to delete this address? You can’t undo this action.</p>
        { showDeleteErrorMessage && <Alert type='error' message={errorMessage} showIcon style={{ marginTop: '10px' }} />}
      </Modal>
    )
  }
}

DeleteAddress.propTypes = {
  showDeleteModal: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  showDeleteErrorMessage: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
}

export default DeleteAddress
